import { Button, Typography } from '@mui/material';
import {
  IntegrationPropertiesFormSchema,
  IntegrationSettingData,
} from '@strength/domain';
import { I18nTranslator } from '@strength/i18n';
import { MdAdd } from '@teamworksdev/icons';
import { useTranslation } from 'react-i18next';
import { Sheet, Slot } from '../../../../components/sheet';
import { CustomSlot } from '../../../../components/sheet/slots';
import { IntegrationProviderSlot } from '../../../../components/sheet/slots/integration-provider-slot';
import { IntegrationProviderOptions } from '../types';

export function IntegrationProvidersSheet({
  integrationProperties,
  onChange,
  integrationProviderOptions,
  disabled = false,
}: {
  integrationProperties: IntegrationPropertiesFormSchema;
  onChange: (integrationProperties: IntegrationPropertiesFormSchema) => void;
  integrationProviderOptions: IntegrationProviderOptions[];
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Sheet
      {...getSlotsForIntegrationProviders({
        integrationProperties,
        onChange: onChange,
        integrationProviderOptions,
        t,
        isReadOnly: disabled,
      })}
      onUndo={() => {}}
      onRedo={() => {}}
      onBulkClear={() => {}}
      getContextMenuContent={(selectionData) => {
        return null;
      }}
      onCopy={() => {}}
      onPaste={() => {}}
      onDragEnd={() => {}}
    />
  );
}

type IntegrationSettingsSlot = Slot<IntegrationSettingData>;
function getSlotsForIntegrationProviders({
  integrationProperties,
  onChange,
  integrationProviderOptions,
  t,
  isReadOnly,
}: {
  integrationProperties: IntegrationPropertiesFormSchema;
  onChange: (integrationProperties: IntegrationPropertiesFormSchema) => void;
  integrationProviderOptions: IntegrationProviderOptions[];
  t: I18nTranslator;
  isReadOnly: boolean;
}) {
  const rowCount = integrationProperties.length + 2;
  const currentY = 0;
  const slots: IntegrationSettingsSlot[] = [];
  const gridSubRows = 1;
  const columnCount = 3;

  slots.push(
    new IntegrationProviderSlot(
      { x: 0, y: currentY },
      integrationProperties,
      onChange,
      integrationProviderOptions,
      isReadOnly,
      gridSubRows,
      t,
    ),
  );

  slots.push(
    new CustomSlot(
      { x: 0, y: rowCount - 1 },
      columnCount,
      1,
      isReadOnly,
      () => (
        <Button
          variant="text"
          sx={{ height: '100%', width: '100%' }}
          onClick={() =>
            onChange([
              ...integrationProperties,
              { provider: '', property: '', value: '' },
            ])
          }
          className="bg-gray-50"
        >
          <MdAdd className="text-black/80" />
          <Typography variant="subtitle1" className="text-black/80">
            {t('addProperty')}
          </Typography>
        </Button>
      ),
    ),
  );

  return {
    slots,
    gridSubRows,
    columnCount,
    rowCount,
  };
}
